import { z } from 'zod';

/** Límite de página por defecto y máximo (contracts/admin-api.md, "Cabeceras y comportamiento transversal"). */
export const PAGE_LIMIT_DEFAULT = 50;
export const PAGE_LIMIT_MAX = 100;

/**
 * Query de paginación por cursor opaco (ULID del último elemento).
 * `limit` llega como string en la query; se coerciona a entero.
 */
export const CursorQuerySchema = z.object({
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(PAGE_LIMIT_MAX).default(PAGE_LIMIT_DEFAULT),
});
export type CursorQuery = z.infer<typeof CursorQuerySchema>;

/** Alias con el nombre usado en tasks.md (T006). */
export const cursorQuery = CursorQuerySchema;

/** `Page<T> = { items: T[], next_cursor: string|null }`. */
export function pageSchema<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    next_cursor: z.string().nullable(),
  });
}

export type Page<T> = { items: T[]; next_cursor: string | null };
